<article class="container py-8">
  <app-actualite-content [actualite]="actualite"></app-actualite-content>
</article>
